import { url, tokenRef } from "api";

// WHAT A PARTNER MAY DO ON EACH COORDINATION TAB, per project (owner,
// 2026-10-15: "on the partner page, i don't see how to enable the
// coordination tabs for them"). The grid, its defaults and what each cell
// opens all come from the server (back/utils/partnerCoordGrants) with the
// answer, so there is no second copy of the rules here to drift.
const headers = () => {
  const h = { "Content-Type": "application/json" };
  const t = localStorage.getItem(tokenRef);
  if (t) h.Authorization = `Bearer ${t}`;
  return h;
};
const handle = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.err || "Request failed");
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

// One partner row's grid: { grants, overrides, defaults, offered, opens, labels, canEdit }.
export const getCoordGrants = (participantId) =>
  fetch(`${url}/partner-admin/coord-grants?participantId=${encodeURIComponent(participantId)}`, { headers: headers() }).then(handle);
// changes: { tab: { verb: true | false | null } } - null puts the cell back to its default.
export const setCoordGrants = (participantId, changes) =>
  fetch(`${url}/partner-admin/coord-grants`, {
    method: "PATCH", headers: headers(), body: JSON.stringify({ participantId, changes }),
  }).then(handle);

// THIS person's tabs on one project: { partner: false } for the project team,
// { partner: true, reader, tabs } for a partner.
export const getMyCoordinationCaps = (projectId) =>
  fetch(`${url}/projects/${projectId}/my-coordination-caps`, { headers: headers() }).then(handle);

// Users and permissions > Partners: every partner person on your projects.
export const getPartnerAccounts = () =>
  fetch(`${url}/partner-directory/accounts`, { headers: headers() }).then(handle);
